import * as config from "config-api";
import { baseFetch, fetch } from "../../index";
import {
    liveStoryContentItem,
    liveStoryUpdates,
} from "../../queries/liveStories.js";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const getLiveStory = (sourceId, isPreview, pubDate) => {
    const fetchContent = baseFetch(isPreview);
    const gqlQuery = liveStoryContentItem(sourceId, isPreview, pubDate);
    return fetchContent(GRAPHQL_BASE_URL, { query: gqlQuery }, false);
};

export const getLiveStoryUpdates = (sourceId, queryArgs) => {
    const gqlQuery = liveStoryUpdates(sourceId, queryArgs);
    return fetch(GRAPHQL_BASE_URL, { query: gqlQuery }, false);
};
